/** @file typedResize: a tile size typed in the Rig block as the handle drag that would give it (pivot kept). */
import { resizeEntry, type SizePivot } from '../viewport/resizeEntry';

/**
 * The entry after typing `size` (whole px, at least 1): per axis the edge away from the pivot moves (the max edge
 * when the pivot sits in the first half, else the min edge, so a pivot at the feet grows the tile upwards), through
 * `resizeEntry`, so the pivot stays on its image pixel exactly as a handle drag of that edge would leave it.
 */
export function typedResize(start: SizePivot, size: readonly [number, number]): SizePivot {
  const side = (k: 0 | 1): number => {
    if (size[k] === start.size[k]) return 0;
    return start.pivot[k] > start.size[k] / 2 ? -1 : 1;
  };
  const sides: [number, number] = [side(0), side(1)];
  const want = (k: 0 | 1): number => Math.max(1, Math.round(size[k]));
  return resizeEntry(start, sides, [sides[0] * (want(0) - start.size[0]), sides[1] * (want(1) - start.size[1])]);
}
